<template>
    <div class="options-group card-text group">
        <div v-if="isCollapsible" :class="headerClasses" @click="isCollapsed = !isCollapsed">
            <div class="label">
                {{ config.label }}
            </div>
        </div>
        <template v-if="!isCollapsed">
            <div v-for="(option, key) in config.options" :key="key">
                <h5 v-if="option.heading && !option.hidden" class="option-heading">
                    {{ option.heading }}
                </h5>
                <component
                    :is="option.type" v-if="!option.hidden"
                    :class="componentClasses" :value="value[key]" :config="option"
                    @input="update(key, $event)"
                ></component>
            </div>
        </template>
    </div>
</template>

<script>

    import OptionSwitch from './OptionSwitch';
    import DropdownList from './DropdownList';
    import RouteOptions from './RouteOptions';
    import OperatorSelector from './OperatorSelector';
    import ChangesInput from './ChangesInput';
    import RadioSelectors from './RadioSelectors';

    export default {
        name: 'OptionsGroup',
        components: {
            OptionSwitch,
            DropdownList,
            RouteOptions,
            OperatorSelector,
            ChangesInput,
            RadioSelectors,
        },
        props: {
            value: {
                type: Object,
                required: false,
                default() {
                    return {};
                },
            },
            config: {
                type: Object,
                default() {
                    return {
                        label: 'Section',
                    };
                },
            },
        },
        data() {
            return {
                isCollapsed: this.config.collapsed,
            };
        },
        computed: {
            headerClasses() {
                return {
                    'collapsible-header': true,
                    collapsed: this.isCollapsed,
                };
            },
            isCollapsible() {
                return this.config.collapsible === true;
            },
            componentClasses() {
                return {
                    'option-component': true,
                    borderless: this.config.borderless === true,
                };
            },
        },
        methods: {
            update(key, value) {
                const model = this.value;
                model[key] = value;
                this.$emit('input', model);
            },
        },
    };

</script>
